import type { Rectangle2d, Point2d } from "@logic/lib/2d"
import {
  boxToPoints,
  findCenterOfPoints,
  findMinMaxPoints,
  pointsToBox,
} from "@logic/lib/2d"
import { atom } from "recoil"

import type { TransactionOperation } from "."
import { findPanelState, panelSelectionState } from "../panels"

// used for debugging
export const selectionBoxState = atom<{ box: Rectangle2d; center: Point2d }>({
  key: `midPointState`,
  default: {
    box: {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
      r: 0,
    },
    center: {
      x: 0,
      y: 0,
    },
  },
})

export const findCenterOfSelectedPanels: TransactionOperation<
  { debug?: boolean },
  Point2d
> = (transactors, { debug = false }) => {
  const { set, get } = transactors
  const selection = get(panelSelectionState)
  const selectedPanels = [...selection].map((id) => get(findPanelState(id)))
  const allOriginalPanelPoints = [...selectedPanels]
    .map((panel) => boxToPoints(panel))
    .flat()
  const centerPoint = findCenterOfPoints(...allOriginalPanelPoints)

  if (debug) {
    const findSelectionBoxNodes = findMinMaxPoints(...allOriginalPanelPoints)
    const { min, max } = findSelectionBoxNodes
    const minMaxBox = { p1: { x: min.x, y: min.y }, p2: { x: max.x, y: max.y } }
    const findSelectionBox = pointsToBox(minMaxBox.p1, minMaxBox.p2)
    set(selectionBoxState, { box: findSelectionBox, center: centerPoint })
  }

  return centerPoint
}
